import { v2Api } from './v2Client';

const LOG = '[SquashAPI courtBookingBlock]';

/** Blocage de réservation en ligne (API CourtBookingBlockController) : sport (null = tous), jours System.DayOfWeek
 * (0 = dimanche), heures "HH:mm" locales, message affiché au joueur, actif. */
function normalizeBlock(row) {
  if (!row || row.id == null) return null;
  return {
    id: String(row.id),
    sport: row.sport || null,
    days_of_week: Array.isArray(row.days_of_week) ? row.days_of_week.map(Number) : [],
    start_time: String(row.start_time || '').slice(0, 5),
    end_time: String(row.end_time || '').slice(0, 5),
    message: row.message || '',
    is_active: row.is_active !== false,
  };
}

/** GET /CourtBookingBlock/list */
export async function listCourtBookingBlocks() {
  try {
    const { data } = await v2Api.get('/CourtBookingBlock/list');
    return (Array.isArray(data) ? data : []).map(normalizeBlock).filter(Boolean);
  } catch (err) {
    console.error(LOG, 'list échoué', err);
    throw err;
  }
}

/** POST /CourtBookingBlock/upsert — sans id = création. */
export async function upsertCourtBookingBlock(payload) {
  try {
    const { data } = await v2Api.post('/CourtBookingBlock/upsert', payload);
    return normalizeBlock(data);
  } catch (err) {
    console.error(LOG, 'upsert échoué', err);
    throw err;
  }
}

/** POST /CourtBookingBlock/delete */
export async function deleteCourtBookingBlock(id) {
  try {
    await v2Api.post('/CourtBookingBlock/delete', { id });
  } catch (err) {
    console.error(LOG, 'delete échoué', err);
    throw err;
  }
}

export const courtBookingBlockService = {
  list: listCourtBookingBlocks,
  upsert: upsertCourtBookingBlock,
  remove: deleteCourtBookingBlock,
};
